// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const triggerPointInTimeWorkflowMutation: any = graphql(`
  mutation TriggerPointInTimeWorkflow($workflowTriggerData: WorkflowTriggerData!) {
    triggerPointInTimeWorkflow(workflowData: $workflowTriggerData)
  }
`);
